<template>
    <a-spin :spinning="loading">
        <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">New
            Payment </h4>
        <div class="mt-5">
            <div class="scrollable-container">
                <a-form-model ref="paymentForm" :model="paymentModel">
                    <a-form-model-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="Customer Name">
                        <a-input v-model="paymentModel.name">
                            <a-icon slot="suffix" type="user" />
                        </a-input>
                    </a-form-model-item>
                    <a-form-model-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="Payment #">
                        <a-input v-model="paymentModel.name" />
                    </a-form-model-item>
                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }"
                                label="Amount Received Ksh">
                                <a-input v-model="paymentModel.name" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }"
                                label="Bank Charges (if any)">
                                <a-input v-model="paymentModel.name" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-form-model-item label="Tax Deducted?" :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }">
                        <a-radio-group v-model="paymentModel.type">
                            <a-radio value="1" name="type">
                                No Tax Deducted
                            </a-radio>
                            <a-radio value="2" name="type">
                                Yes
                            </a-radio>

                        </a-radio-group>
                    </a-form-model-item>
                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }"
                                label="Payment Date">
                                <a-input v-model="paymentModel.name" />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }"
                                label="Payment Mode">
                                <a-select style="width: 190px">
                                    <a-select-option value="all">
                                        Cash
                                    </a-select-option>
                                    <a-select-option value="0">
                                        Bank Remittance
                                    </a-select-option>
                                    <a-select-option value="1">
                                        Bank Transfer
                                    </a-select-option>
                                    <a-select-option value="2">
                                        Cheque
                                    </a-select-option>
                                    <a-select-option value="3">
                                        Credit Card
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="12">
                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }" label="Deposit To">
                                <a-select style="width: 190px">
                                    <a-select-option value="all">
                                        D1
                                    </a-select-option>
                                    <a-select-option value="0">
                                        D2
                                    </a-select-option>
                                    <a-select-option value="1">
                                        D3
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-model-item :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }"
                                label="Reference #">
                                <a-input v-model="paymentModel.name" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-form-model-item label="Add Note">
                        <a-input v-model="paymentModel.desc" type="textarea" />
                    </a-form-model-item>

                    <div>
                        <p style="color:#111827">Attachment</p>
                        <div>
                            <div class="clearfix mt-3">
                                <a-upload action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                    list-type="picture-card" :file-list="fileList" :beforeUpload="beforeUpload"
                                    @preview="handlePreview" @change="handleChange" class="upload">
                                    <div>
                                        <a-icon type="plus" />
                                        <div class="ant-upload-text">
                                            Upload
                                        </div>
                                    </div>
                                </a-upload>
                                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                                    <img alt="example" style="width: 100%" :src="previewImage" />
                                    <!-- <check-box :value="selectedValue" :msg="msg" @change="changeValue" :file="fileSelected"></check-box> -->
                                    <h4 style="display:flex;justify-content: center;margin-top:15px">Image Name: <span
                                            style="margin-left:10px">{{fileSelected.name}}</span></h4>
                                    <div style="display:flex;justify-content: center;">
                                    </div>
                                </a-modal>
                            </div>
                        </div>
                        <p style="color: #111827; font-sie: 10px">You can upload a maximum of 5 files, 5MB each</p>
                    </div>
                    <a-form-model-item :wrapper-col="{ span: 14, offset: 0 }" class="mt-5">
                        <a-button style="background: #418a49;color:#fff;">
                            Record Payment
                        </a-button>
                        <a-button @click="cancelModal" style="margin-left: 10px;">
                            Cancel
                        </a-button>
                    </a-form-model-item>
                </a-form-model>
            </div>

            <!-- <div style="display:flex;justify-content:center;margin-top:20px">
                <a-button style="background: #418a49;height:59px;color:#fff;width:263px;border-radius:5px;">
                    Record Payment
                </a-button>
            </div> -->

        </div>
    </a-spin>

</template>
<script>

// import moment from 'moment';
// import _ from 'lodash';
// import XLSX from "xlsx";
import { NotificationMixins }  from '@/mixins/NotificationMixins'
import { mapActions } from 'vuex';


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}


export default {
    name:"AddNewPaymentForm",
        mixins: [ NotificationMixins ],
        components: {
           
        },
        data(){
            return{
                loading: false,
                imageUrl: '',
                paymentModalVisible: false,
                paymentModel: {},
                data: {},
                fileList: [],
                previewVisible: false,
                previewImage: '',
                imgSelected: false,
                fileSelected: {},
            }
        },
        methods:{
            ...mapActions(['setPreviewInfo','addStockToWarehouse']),
            handleReceiveOrderCancel(){
                this.receiveOrderVisible = false
            },
            beforeUpload(file) {
                // console.log("file type | ", file.type)
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';

                if (!isJpgOrPng) {
                    this.fileList = [];
                    this.showErrorAlert("You can only upload PNG or JPEG file!")
                    // console.log("fileList not png | ", this.fileList)
                    return false;
                } else {
                    // console.log("fileList png | ", this.fileList)
                    this.fileList = [...this.fileList, file];
                    return false;
                }
            },
            async handlePreview(file) {
                if (!file.url && !file.preview) {
                    file.preview = await getBase64(file.originFileObj);
                }
                this.fileSelected = file
                this.previewImage = file.url || file.preview;
                this.previewVisible = true;
            },
            handleCancel() {
                this.previewVisible = false;
            },
            handleChange({ fileList }) {
                this.fileList = fileList;
            },
            cancelPurchaseOrder(data){
                const request = {
                    status: 4,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
            cancelModal() {
                this.$emit('closeModal', false);
            },
            completedOrder(data){
                const request = {
                    status: 3,
                    id: data.id
                }
                this.$emit('orderStatus',request) 
            },
        
            async handleAddInventoryTransfer(data){
                this.loading = true;
                const response = await this.addStockToWarehouse(data);
                this.loading = false;
                if (response.status === 200) {
                    this.receiveOrderVisible = false
                    this.showSuccessAlert("Purchase Order Received Successfully");
                    this.$emit('orderData', true)  
                } else {
                    // // console.log("Error | ", response);
                    this.showErrorAlert(response.data.messages);
                }  
                 
            },
            recordPayment() {
                this.$refs.paymentForm.validate(async (valid) => {
                    if (valid) {
                        this.loading = true
                        const request = {
                            id: this.invoiceId,
                            data: {
                                orderType: parseInt(this.orderType),
                                issuer: parseInt(this.paymentModel.issuer),
                                paymentAccount: this.allowedPayment.includes(parseInt(this.paymentModel.issuer)) ? this.paymentModel.paymentAccount : this.customerPhoneNumber,
                                amount: parseFloat(this.paymentModel.amount),
                                orderId: this.orderId,
                                reference: this.paymentModel.reference
                            }
                        }

                        const response = await this.$store.dispatch('invoices/payInvoice', request)
                        this.loading = false
                        if (response.status === 200) {
                            this.paymentModalVisible = false
                            this.showSuccessAlert('Payment Made Successfully');
                            this.$refs.paymentForm.resetFields()
                        } else {
                            this.showErrorAlert(response.data.messages);
                        }
                    } else {
                        return false
                    }
                })
            },
        },
        computed:{
            
        },
        // watch: { 
        //     contacts:{
        //         immediate: true, 
        //         handler () {
        //             // this.tablePurchaseOrders = newValues
        //         }
                
        //     }    
        // }
    }
</script>

<style  scoped>
.avatar-uploader>.ant-upload {
    width: 128px;
    height: 128px;
}

.ant-upload-select-picture-card i {
    font-size: 32px;
    color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
    margin-top: 8px;
    color: #666;
}

.scrollable-container {
    height: 700px;
    padding: 10px;
    overflow-y: auto;
}

.scrollable-container::-webkit-scrollbar {
    display: none;
}
</style>